module.exports = __webpack_public_path__ + "static/media/ci-panda.0e48bd01.png";